import { ReactNode } from "react";
import styles from "./StyledRadioButton.module.css";
import classNames from "classnames";

type Props<T extends string> = React.ComponentProps<"input"> & {
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  value?: T;
} & (
    | {
        label: string;
        "aria-label"?: never;
      }
    | {
        label: Exclude<ReactNode, "string">;
        "aria-label": string;
      }
  );

export default function StyledRadioButton<T extends string>({
  className,
  labelClassName,
  inputClassName,
  "aria-label": ariaLabel,
  label,
  ...props
}: Props<T>) {
  return (
    <label className={className}>
      <input
        {...props}
        className={classNames(styles.input, inputClassName)}
        type="radio"
        aria-label={ariaLabel}
      />
      <span className={labelClassName}>{label}</span>
    </label>
  );
}
